import _classCallCheck from "/Users/dstein/dev/jaxcore/spin-a-sketch/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/dstein/dev/jaxcore/spin-a-sketch/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/dstein/dev/jaxcore/spin-a-sketch/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/dstein/dev/jaxcore/spin-a-sketch/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/dstein/dev/jaxcore/spin-a-sketch/node_modules/@babel/runtime/helpers/esm/inherits";
import EventEmitter from 'events';

var Sound =
/*#__PURE__*/
function (_EventEmitter) {
  _inherits(Sound, _EventEmitter);

  function Sound(url, options) {
    var _this;

    _classCallCheck(this, Sound);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Sound).call(this));
    if (!options) options = {};
    if (options.context) _this.context = options.context;

    if (options.source) {
      _this.source = options.source;
    }

    _this.connected = false;
    _this.loaded = false;
    _this.looping = false;

    if (options.autoplay) {
      _this.connect();

      _this.on('load', function () {
        if (options.loop) {
          _this.loop();
        } else _this.play(options.callback);
      });
    }

    if (typeof url === 'string') {
      _this.url = url;

      _this.load();
    } else if (typeof url === 'object') {
      _this.loadArrayBuffer(url);
    }

    return _this;
  }

  _createClass(Sound, [{
    key: "connect",
    value: function connect() {
      if (!this.context) {
        this.createContext(); // this.context = new AudioContext();
        // this.reset();
      } // if (!this.source) {
      // 	this.source = this.context.createBufferSource();
      // }


      if (!this.source.buffer) this.source.buffer = this.buffer;
      this.source.connect(this.context.destination);
      this.connected = true;
    }
  }, {
    key: "loadArrayBuffer",
    value: function loadArrayBuffer(data) {}
  }, {
    key: "load",
    value: function load() {
      var _this2 = this;

      var request = new XMLHttpRequest();
      request.open('GET', this.url, true);
      request.responseType = 'arraybuffer';

      request.onload = function () {
        _this2.response = request.response;

        if (_this2.context) {
          // debugger;
          _this2.loadData();
        } else {
          console.log('loaded no context', _this2.url);
        }
      };

      request.send();
    }
  }, {
    key: "loadData",
    value: function loadData() {
      var _this3 = this;

      if (!this.response) {
        return;
      }

      if (this.context) {
        this.context.decodeAudioData(this.response, function (response) {
          _this3.buffer = response;

          if (_this3.source) {
            // debugger;
            _this3.source.buffer = _this3.buffer;
          }

          _this3.loaded = true;

          _this3.emit('load');
        }, function (e) {
          console.error('Sound: failed to load', this.url); // this.emit('error', e);
        });
      }
    }
  }, {
    key: "createContext",
    value: function createContext() {
      var AudioContext = window.AudioContext || window.webkitAudioContext;
      this.context = new AudioContext();
      this.source = this.context.createBufferSource();
    }
  }, {
    key: "reset",
    value: function reset() {
      this.createContext();
      this.connect(); // this.source.buffer = this.buffer;
      // this.source.connect(this.context.destination);
    }
  }, {
    key: "pause",
    value: function pause() {
      this.source.pause();
    }
  }, {
    key: "resume",
    value: function resume() {
      this.source.resume();
    }
  }, {
    key: "play",
    value: function play(callback) {
      var _this4 = this;

      if (this.isPlaying) {
        console.log('isPlaying');
        return;
      }

      if (!this.loaded) {
        if (!this.context) {
          this.createContext();
        }

        this.once('load', function () {
          _this4.connect();

          _this4.source.loop = _this4.looping;

          _this4.source.onended = function () {
            _this4.stop();

            if (callback) callback();
          };

          _this4.isPlaying = true;

          if (_this4.source) {
            try {
              _this4.source.start(0);
            } catch (e) {
              console.log(e);
            }
          }
        });
        this.loadData();
      } else {
        if (!this.connected) {
          // debugger;
          this.connect();
        }

        this.source.onended = function () {
          // debugger;
          _this4.stop();

          if (callback) callback();
        };

        this.isPlaying = true;
        if (this.source) this.source.start(0);
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      this.isPlaying = false;
      this.source.stop();
      this.source.disconnect();
      this.context.close();
      this.connected = false;
      this.looping = false;
      this.reset();
    }
  }, {
    key: "loop",
    value: function loop() {
      this.looping = true;
      this.play(); // if (!this.loaded) {
      // 	this.once('load', () => {
      // 		this.connect();
      // 		this.source.loop = true;
      // 		this.source.start(0);
      // 	});
      // 	this.load();
      // }
      // else {
      // 	if (!this.connected) this.connect();
      // }
      // this.source.loop = true;
      // this.source.start(0);
    }
  }]);

  return Sound;
}(EventEmitter);

export default Sound;